import dom, { Fragment }  from "../../../dist/jsx-render/dom"
import JSXComponent from "../../../dist/jsx-render/JSXComponent"
import { MsoTable } from "./MsoTable";
import { ColumnBase } from "./ColumnBase";
import { ListItem } from "../../Model/ListItem";
import { app } from "../../Frame/App";
import { TableColumnTypes } from "./TableColumnTypes";

type CheckboxRowComponentProps = {
    value: string;
    text: string;
    column: ColumnBase;
    parent: FilterPopupTreeComponent;
}

class CheckboxRowComponent extends JSXComponent {
    props: CheckboxRowComponentProps;

    constructor(props: CheckboxRowComponentProps) {
        super(props);
    }

    inputElement: HTMLInputElement = 
        <input type="checkbox" className="filter-check" value={this.props.value} />

    labelElement: HTMLLabelElement = 
        <label  className="filter-label mb-0">{this.props.text}</label>

    element: HTMLElement =
        <div className="tree-check-row">
            {this.inputElement}
            {this.labelElement}
        </div>

    render() {
        this.inputElement.id = app.createGuid();
        this.labelElement.htmlFor = this.inputElement.id;
        if (this.props.column.isFilterChecked(this.props.value)) {
            this.inputElement.checked = true;
        }
        this.props.parent.checkboxList.push(this);
        this.inputElement.addEventListener("click", () => {
            this.props.parent.onCheckboxClick(this);
        });
        return this.element;
    }
}

export type FilterPopupTreeComponentProps = {
    table: MsoTable;
    column: ColumnBase;
}

export class FilterPopupTreeComponent extends JSXComponent {
    public checkboxList: Array<CheckboxRowComponent> = [];
    public rows: HTMLElement[] =[];
    props: FilterPopupTreeComponentProps;
    rowItemList: ListItem[] = [];

    constructor(props: FilterPopupTreeComponentProps) {
        super(props);
    }
   
    getRowItems = () => {
        // get distinct string values
        if (this.props.column.type == TableColumnTypes.String && this.props.column.field.startsWith("CAT#")) {
            let stringValues: string[] = [];
            this.props.column.getUniqueVisibleItems(this.props.table).map((item: ListItem) => {
                if (item.id != "null") {
                    var splitItem = item.name.split(',');
                    for (let item in splitItem) {
                        if (!stringValues.includes(splitItem[item].trim())) {
                            stringValues.push(splitItem[item].trim());
                        }
                    }
                }
                else
                    stringValues.push(item.id);
            });

            stringValues.map(item => {
                let row: ListItem;
                if (item == "null")
                    row = { id: item, name: `${Resources.Common.null}` };
                else
                    row = { id: item, name: item };
                this.rowItemList.push(row);
            })
        }
        else {
            this.props.column.getUniqueVisibleItems(this.props.table).map((item: ListItem) => {
                this.rowItemList.push(item);
            })
        }
    }

    element: HTMLElement = <div className="mt-tree">
        <CheckboxRowComponent value="@all@" text={Resources.Common.selectAll} parent={this} column={this.props.column} />
        {this.getRowItems()}
        {this.rowItemList.map((item: ListItem) => 
            <CheckboxRowComponent value={item.id} text={item.name} parent={this} column={this.props.column} />
        )}
    </div>

    
    render() {
        this.updateAllCheckBoxes();
        this.getTreeRows();
        return this.element;
    }


    onCheckboxClick(checkbox: CheckboxRowComponent) {
        if (checkbox.inputElement.value == "@all@") {
            for (var i = 1; i < this.checkboxList.length; i++) {
                this.checkboxList[i].inputElement.checked = checkbox.inputElement.checked;
            }
            // TODO
            /*if (years) {
                for (let id in years) {
                    years[id].allClicked(control.checked);
                }
            }*/
        }
        else {
            this.updateAllCheckBoxes();
        }
    }

    updateAllCheckBoxes() {
        let checkAll = true;
        for (var i = 1; i < this.checkboxList.length; i++) {
            if (!this.checkboxList[i].inputElement.checked) {
                checkAll = false;
                break;
            }
        }
        this.checkboxList[0].inputElement.checked = checkAll;
    }

    getTreeRows() {
        this.element.querySelectorAll(".tree-check-row").forEach((element: HTMLElement) => {
            this.rows.push(element);
        })
    }
}